module.exports = __webpack_public_path__ + "img/24exp.b8cfde93.jpg";